module.exports = __webpack_public_path__ + "img/footer.4b386ab5.png";